import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Asset, AssetType, parseContentType, UploadAsset} from '../model/asset/Asset';

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  constructor(private http: HttpClient) {
  }


  private static readonly ASSETS_BASE_URL = '/assets';

  registerAssetUpload(type: AssetType, file: File): Observable<Asset> {
    const data: UploadAsset = {
      type: type,
      name: file.name,
      content_type: parseContentType(file)
    };

    return this.http.post(`${environment.api.host}${AssetService.ASSETS_BASE_URL}`, data)
      .pipe(
        map(data => Asset.parse(data as UploadAsset))
      );
  }

  uploadContent(url: string, file: File): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': parseContentType(file)});
    const options = {headers};

    return this.http.put(url, file, options);
  }

}
